import {
  __name
} from "../../chunk-7QVYU63E.js";
import { Permission } from "#rbac/permission.js";
import { TeamRole } from "#rbac/teamRole.js";
const VIEWER_PERMISSIONS = [
  Permission.ViewApps,
  Permission.ViewAppLogs,
  Permission.ViewAppConfig
];
const DEVELOPER_PERMISSIONS = [
  ...VIEWER_PERMISSIONS,
  Permission.ManageAdminApiKeys,
  Permission.CreateApps,
  Permission.DeleteApps,
  Permission.EditAppConfig,
  Permission.ManageWebhooks,
  Permission.ViewActivityLog
];
const ADMIN_PERMISSIONS = [
  ...DEVELOPER_PERMISSIONS,
  Permission.ManageTeamSettings,
  Permission.ViewTeamSettings,
  Permission.ManageMembers,
  Permission.AssignRoles
];
const ROLE_PERMISSION_MATRIX = {
  [TeamRole.Viewer]: VIEWER_PERMISSIONS,
  [TeamRole.Developer]: DEVELOPER_PERMISSIONS,
  [TeamRole.Admin]: ADMIN_PERMISSIONS
};
const getPermissions = /* @__PURE__ */ __name((role) => [
  ...ROLE_PERMISSION_MATRIX[role]
], "getPermissions");
const hasPermission = /* @__PURE__ */ __name((role, permission) => ROLE_PERMISSION_MATRIX[role].includes(permission), "hasPermission");
export {
  getPermissions,
  hasPermission
};
//# sourceMappingURL=rolePermissionMatrix.js.map